import React, { useState, useEffect } from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Grid,
  Typography,
  TextField,
  InputAdornment,
  Checkbox,
  Paper,
} from '@mui/material';
import { Search, X } from 'lucide-react';

export const ItemSelectionModal = ({ open, onClose, onItemSelect }) => {
  const [items, setItems] = useState([]);
  const [searchTerm, setSearchTerm] = useState('');
  const [selectedItems, setSelectedItems] = useState([]);

  useEffect(() => {
    const fetchItems = async () => {
      try {
        const response = await fetch(
          // `https://ibretailapi.abisaio.com/api/itemByParm/GetbyCategory/R622/ALL`
        );
        const data = await response.json();
        setItems(data);
      } catch (error) {
        console.error('Error fetching items:', error);
      }
    };

    if (open) {
      fetchItems();
    }
  }, [open]);

  const handleItemToggle = (item) => {
    setSelectedItems((prev) => {
      const exists = prev.find((i) => i.itemID === item.itemID);
      if (exists) {
        return prev.filter((i) => i.itemID !== item.itemID);
      } else {
        return [...prev, { ...item, quantity: 1 }];
      }
    });
  };

  const handleConfirm = () => {
    onItemSelect(selectedItems);
    onClose();
  };

  const filteredItems = items.filter((item) =>
    item.itemName.toLowerCase().includes(searchTerm.toLowerCase())
  );

  return (
    <Dialog open={open} onClose={onClose} maxWidth="md" fullWidth>
      <DialogTitle>
        <Typography variant="h6">Select Items</Typography>
        <TextField
          fullWidth
          size="small"
          placeholder="Search items..."
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                <Search size={20} />
              </InputAdornment>
            ),
          }}
          sx={{ mt: 2 }}
        />
      </DialogTitle>
      <DialogContent>
        <Grid container spacing={2}>
          {filteredItems.map((item) => {
            const isSelected = selectedItems.some((i) => i.itemID === item.itemID);
            return (
              <Grid item xs={12} sm={6} key={item.itemID}>
                <Paper
                  sx={{
                    p: 2,
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'space-between',
                    bgcolor: isSelected ? 'primary.50' : 'white',
                    '&:hover': {
                      bgcolor: isSelected ? 'primary.100' : 'grey.100',
                    },
                    cursor: 'pointer',
                  }}
                  onClick={() => handleItemToggle(item)}
                >
                  <Checkbox
                    checked={isSelected}
                    size="small"
                    sx={{ mr: 2 }}
                  />
                  <div>
                    <Typography variant="body1" noWrap>
                      {item.itemName}
                    </Typography>
                    <Typography variant="caption" color="textSecondary">
                      Part Number: {item.partnumber}
                    </Typography>
                  </div>
                </Paper>
              </Grid>
            );
          })}
        </Grid>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} startIcon={<X />}>
          Cancel
        </Button>
        <Button
          onClick={handleConfirm}
          variant="contained"
          disabled={selectedItems.length === 0}
        >
          Add Selected Items ({selectedItems.length})
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ItemSelectionModal;
